import { render, staticRenderFns } from "./SubTableDetail.vue?vue&type=template&id=05118680&"
import script from "./SubTableDetail.vue?vue&type=script&lang=js&"
export * from "./SubTableDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports